import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PageTitle } from '../../../../_metronic/layout/core';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import AgTable from '../../../Components/Table/AgTable';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

export default function RankingVentasPorMall({ title }) {

    const animatedComponents = makeAnimated();
    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas().list[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();
    const [inflacion, setInflacion] = useState(false)
    const [dateRangeError, setDateRangeError] = useState(false)

    const getOptionValue = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeGraphType = (inputValue) => {
        //setEnableQuery(true); //Everytime the select changes, it enables the useQuery condition for ChartFromServer
        setUnidadEconomica(inputValue);
    }

    const onChangeInflacion = () => {
        setInflacion(!inflacion);
    }


    const dRango = new Date();
    const yearRango = dRango.getFullYear();
    const monthRango = dRango.getMonth();

    const [date1Rango, setDate1Rango] = useState(new Date(yearRango, monthRango, 1));
    const [date2Rango, setDate2Rango] = useState(new Date());

    const [dateRange, setDateRange] = useState([date1Rango, date2Rango]);
    const [startDate, endDate] = dateRange;

    let dateFormatedDiaMesInicio = null;
    if (dateRange[0])
        dateFormatedDiaMesInicio = ("0" + (dateRange[0].getDate())).slice(-2) + "/" + ("0" + (dateRange[0].getMonth() + 1)).slice(-2);

    let dateFormatedDiaMesFin = null;
    if (dateRange[1])
        dateFormatedDiaMesFin = ("0" + (dateRange[1].getDate())).slice(-2) + "/" + ("0" + (dateRange[1].getMonth() + 1)).slice(-2);

    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();
    const [año1, setAño1] = useState(new Date());
    let dateFormated1 = año1.getFullYear();

    const [año2, setAño2] = useState(new Date(Utilities.getAnioComparativo(), month, day));
    let dateFormated2 = año2.getFullYear();

    registerLocale('es', es);

    const [value, onChangeValue] = useState([new Date(year, month, 1), new Date()]);

    let header = [
        {
            headerName: 'Orden',
            field: 'orden',
            type: 'rightAligned',
        },
        {
            headerName: 'Categoría',
            field: 'categoria',
        },
        {
            headerName: 'Contrato',
            field: 'contrato',
            type: 'rightAligned',
        },
        {
            headerName: 'Locatario',
            field: 'locatario',
        },
        {
            headerName: 'Ventas ' + año1.getFullYear(),
            field: 'ventasAnio1',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventasAnio1, true)}</>
            )
        },
        {
            headerName: 'Ventas ' + año2.getFullYear(),
            field: 'ventasAnio2',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventasAnio2, true)}</>
            )
        },
        {
            headerName: 'Cumpl Vtas',
            field: 'cumplimientoAnio1',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.cumplimientoAnio1)}</>
            )
        },
        {
            headerName: 'Sup Vta ' + año1.getFullYear(),
            field: 'superfVtaAnio1',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.superfVtaAnio1, true)}</>
            )
        },
        {
            headerName: 'Sup Vta ' + año2.getFullYear(),
            field: 'superfVtaAnio2',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.superfVtaAnio2, true)}</>
            )
        },
        {
            headerComponent: () => (<span>Vta m<sup>2</sup> {año1.getFullYear()}</span>),
            field: 'vtaM2Anio1',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.vtaM2Anio1, true)}</>
            )
        },
        {
            headerComponent: () => (<span>Vta m<sup>2</sup> {año2.getFullYear()}</span>),
            field: 'vtaM2Anio2',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.vtaM2Anio2, true)}</>
            )
        },
        {
            headerComponent: () => (<span>Cumpl Vta m<sup>2</sup></span>),
            field: 'cumplimiento2',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.cumplimiento2, true)}</>
            )
        },
        {
            headerName: 'Ticket ' + año1.getFullYear(),
            field: 'ticketsAnio1',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsAnio1, true)}</>
            )
        },
        {
            headerName: 'Ticket ' + año2.getFullYear(),
            field: 'ticketsAnio2',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsAnio2, true)}</>
            )
        },
        {
            headerName: 'Cumpl Ticket',
            field: 'cumplimiento3',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.cumplimiento3)}</>
            )
        },
        {
            headerName: 'Ticket Pr. ' + año1.getFullYear(),
            field: 'ticketsPromedioAnio1',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsPromedioAnio1, true)}</>
            )
        },
        {
            headerName: 'Ticket Pr. ' + año2.getFullYear(),
            field: 'ticketsPromedioAnio2',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsPromedioAnio2, true)}</>
            )
        },
        {
            headerName: 'Cumpl Ticket Prom',
            field: 'cumplimiento4',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.cumplimiento4)}</>
            )
        }
    ];

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.RANKING_MALL]} >
                <PageTitle>{title}</PageTitle>

                <div className="card my-5">
                    <div className="card-header border-0 pt-5 row g-3 flex-wrap d-flex flex-row">
                        
                        <div className="col-12 col-sm-6 col-md-3">
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                            <Select
                                classNamePrefix='filter'
                                components={animatedComponents}
                                defaultValue={getOptionValue(unidadesEconomicasList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={unidadesEconomicasList.list}
                                onChange={(onChangeGraphType)}
                            />
                        </div>
                        <div className='col-12 col-sm-6 col-md-2'>
                            <div className='p-2 inflacion form-check form-switch form-switch-sm form-check-custom form-check-solid'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    name='inflacion'
                                    defaultChecked={false}
                                    onChange={(onChangeInflacion)}
                                />
                                <label className='form-check-label'>Inflación</label>
                            </div>
                        </div>

                        <div className='col-12 col-sm-6 col-md-5'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Rango de Fecha:</div>
                            <DateRangePicker
                                onChange={(dateRange) => {
                                    onChangeValue(dateRange)
                                    if(dateRange) {
                                        if(dateRange[0].getFullYear() === dateRange[1].getFullYear()){
                                            setAño1(dateRange[0])
                                            dateRange && setDateRange(dateRange);
                                            setDateRangeError(false)
                                        } else {
                                            setDateRangeError(true)
                                        }
                                    }
                                }}
                                value={value}
                                format="dd/MM/y"
                                className="form-control form-control-transparent pe-5 fit-content-width"
                                locale="es"
                                minDate={new Date(2017, 0, 1)}
                            />
                            <>{dateRangeError && <span className="text-danger">El rango de fechas debe estar dentro del mismo año</span>}</>
                        </div>

                        <div className='col-12 col-sm-6 col-md-2'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Año Comparativo:</div>
                            <DatePicker
                                className="form-control form-control-transparent pe-5"
                                locale="es"
                                selected={año2}
                                onChange={(dateX) => dateX && setAño2(dateX)}
                                dateFormat="yyyy"
                                showYearPicker
                                minDate={Utilities.add_years(new Date(), -6)}
                                maxDate={new Date()}
                            />
                        </div>
                        

                    </div>

                    <div className="card-body tab-content pt-0">
                        <AgTable
                            idContent={"RankingVentasPorMall" + unidadEconomica.value + inflacion + (dateRange[0] != null ? Utilities.formaterDate(dateRange[0]) : "") + " / " + (dateRange[1] != null ? Utilities.formaterDate(dateRange[1]) : "") + " " + dateFormated1 + " " + dateFormated2}
                            apiService={Api.RankingVentasPorMall}
                            setAuxData={null}
                            header={header}
                            titleExcel={"Ranking Ventas Por Mall - " + unidadEconomica.value + " - Inflacion: " + inflacion + " " + (dateRange[0] != null ? Utilities.formaterDate(dateRange[0]) : "") + " / " + (dateRange[1] != null ? Utilities.formaterDate(dateRange[1]) : "") + " " + dateFormated1 + " " + dateFormated2}
                            conditions={dateRange[0] != null && dateRange[1] != null}
                            args={{ unidadEconomicaId: unidadEconomica.value, inflacion: inflacion, diaMesInicio: dateRange[0] && dateFormatedDiaMesInicio, diaMesFin: dateRange[1] && dateFormatedDiaMesFin, anio1: dateFormated1, anio2: dateFormated2, token: useGetToken() }}
                            hideFilter={false}
                            paginationPageSize={8}
                            rowHeight={40}
                            useFlex={false}
                        />
                    </div>
                </div>
            </PermissionsGate>
        </>
    )
}